<a mat-list-item [ngStyle]="{'padding-left': (depth * 12) + 'px'}" (click)="onItemSelected(item)" [ngClass]="{'active': item.label == sharedService.menuItemSeleccionado.label ? true: false, 'expanded': expanded}">
  <i *ngIf="item.label == sharedService.menuItemSeleccionado.label" style="padding-right: 5px;" class="fas fa-chevron-right"></i>
  <i class="routeIcon {{item.faIcon}}"></i> {{item.label}}
</a>
<div *ngIf="expanded">
  <app-menu-list-item *ngFor="let child of item.items" [item]="child" [depth]="depth+1">
  </app-menu-list-item>
</div>
